import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import footerMenuJSON from '../../../assets/json/footermenu.json';
import socialMenuJSON from '../../../assets/json/socialmenu.json';
import { SanitizeHtmlPipe } from '../../providers/sanitize.pipe';
import { UtilityService } from '../../services/utility.service';

@Component({
	selector: 'app-footer-component',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	imports: [SanitizeHtmlPipe],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
	footerMenu = footerMenuJSON;
	socialMenu = socialMenuJSON;
	template = '';

	private utilityService = inject(UtilityService);
	private platformId: object = inject(PLATFORM_ID);
	private cdRef = inject(ChangeDetectorRef);

	ngOnInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.utilityService.getFooterDisclaimer().subscribe((text) => {
				if (text) {
					this.template = text;
					this.cdRef.detectChanges();
				}
			});
		}
	}
}
